<template>
  <InternalLayout class="mail-service-page">
    <header class="mail-service-page__header">
      <h2>
        {{ $t('ADVERTISEMENT.MAIL_SERVICE') }}
      </h2>

      <ElButton type="primary" @click="showNewMailModal">
        {{ $t('ADVERTISEMENT.MAIL_SERVICE.NEW_NOTIFICATION_BUTTON') }}
      </ElButton>
    </header>
    <Card no-padding>
      <MailServiceSearchForm @searchEmails="searchEmails" />

      <MailServiceList :data="filteredData" />
    </Card>

    <MailServicePageAddModal v-model="shouldShowNewMailModal" />
  </InternalLayout>
</template>

<script>
import InternalLayout from '@@/common/layout/InternalLayout';
import Card from '@@/common/Card';
import MailServiceList from './MailServiceList';
import MailServiceSearchForm from './MailServiceSearchForm';
import MailServicePageAddModal from '../common/components/MailServicePageAddModal';
import { mapGetters } from 'vuex';
import { MAIL_SERVICE } from '@/store/types';

export default {
  name: 'MailServicePage',
  components: {
    Card,
    MailServiceList,
    InternalLayout,
    MailServiceSearchForm,
    MailServicePageAddModal,
  },
  data() {
    return {
      shouldShowNewMailModal: false,
      emailToSearch: '',
    };
  },
  computed: {
    ...mapGetters({
      data: MAIL_SERVICE,
    }),
    filteredData() {
      if (!this.emailToSearch) return this.data;
      return this.data.filter(({ email }) =>
        email.includes(this.emailToSearch),
      );
    },
  },
  methods: {
    searchEmails(emailToSearch) {
      this.emailToSearch = emailToSearch;
    },
    showNewMailModal() {
      this.shouldShowNewMailModal = true;
    },
  },
};
</script>

<style lang="scss">
.mail-service-page {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
